import React, { useContext } from 'react'
import { TicketMessageStyles } from './Style'
import { Img } from 'styles/GlobalStyle'
import { formatDateTime } from 'utils/formatter'
import { Avatar, SvgIcon } from '@mui/material'
import { Three, Five } from 'assets'
import { TicketMessageMenu } from '.'
import { Chip } from 'components/Form'
import { useSelector } from 'react-redux'
import { AbilityContext } from 'components/Permissions/Can'
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { alerts } from 'keys'
import { ReactComponent as EditIcon } from 'assets/icons/Edit.svg';

const TicketMessage = (props) => {
    const { hideMenu, id, is_superuser, content, written_by_name, written_by_user_id, written_by_user_image, create_date, update_date, image } = props
    const { user } = useSelector(state => state.user)
    const ability = useContext(AbilityContext)
    const dispatch = useDispatch()

    let avatar = written_by_user_image
    if (!avatar)
        avatar = is_superuser ? Five : Three

    const handleImageClick = () => {
        dispatch(actions.setAlerts({ key: alerts.preview, value: { open: true, props: image, type: "img" } }))
    };

    return (
        <TicketMessageStyles is_superuser={is_superuser}>
            <div className='ticket-message-header'>
                <div className='profile-image'>
                    <Avatar src={avatar} />
                </div>
                <div className='ticket-message-details'>
                    <div className='ticket-user-name'>
                        {written_by_name}
                    </div>
                    <div className='date'>
                        {create_date && formatDateTime(create_date)}
                    </div>
                    {create_date != update_date && update_date &&
                        <div className='wrap-update-date'>
                            <div className='message-edited'>
                                <SvgIcon component={EditIcon} inheritViewBox />
                                <span>{"עריכה"}</span>
                            </div>
                            <span className='update-date'>{update_date && formatDateTime(update_date)}</span>
                        </div>}
                    <div className='superuser-chip'>
                        {is_superuser && <Chip color="thirdly" borderColor={"red"}>{"צוות"}</Chip>}
                    </div>
                </div>
            </div>
            <div className='wrap-message-content'>
                <div className='message-content'>
                    {content}
                    {image &&
                        <div className='ticket-message-image'>
                            <Img src={image} onClick={handleImageClick} />
                        </div>}
                </div>
                <div className='message-menu'>
                    {(user?.user_id == written_by_user_id || ability.can("manage", "super-user"))
                        && !hideMenu &&
                        <TicketMessageMenu {...props} />}
                </div>
            </div>
        </TicketMessageStyles>
    )
}

export default TicketMessage